<template>
  <div class="ordinaryStoreDetail-container">
    <div class="container">
      <div class="store-detail" v-if="pageData.total">
        <div class="store-header">
          <div class="store-header-left">
            <div class="store-img">
              <img :src="storeInfo.logoUrl" alt="">
            </div>
            <div class="store-info">
              <div class="store-type-name">
                <img class="store-type" v-if="storeInfo.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                <img class="store-type" v-else-if="storeInfo.storeType === 'S'" src="@/assets/images/pt-zy.png" alt="">
                <span class="store-name">{{ storeInfo.storeName }}</span>
              </div>
              <div class="store-description" ref="description" :class="{more: isShow}">
                {{ storeInfo.detail }}
                <div v-if="descShowStatus" class="desc-openClose" @click="handleChangeIsShow">
                  {{ !isShow ? '展开' : '关闭' }}
                  <el-icon v-show="isShow" class="el-icon-caret-top"></el-icon>  
                  <el-icon v-show="!isShow" class="el-icon-caret-bottom"></el-icon>  
                </div>
              </div>
            </div>
          </div>
          <div class="store-header-right">
            <span class="contact" @click="handleStorePhone(storeInfo.note)"><el-icon class="el-icon-phone-outline"></el-icon>联系商家</span>
          </div>
        </div>
        <div class="good-search">
          <div class="good-filter">
            <div class="sortWrap">
              <p 
                :class="(activeTab === 'descNew' || activeTab === 'ascNew') ? 'activeSort' : ''" 
                @click="priceSort('new')"
              >最新
                <i class="el-icon-caret-top" :class="activeTab === 'ascNew' ? 'activeSort' : ''"></i>
                <i class="el-icon-caret-bottom" :class="activeTab === 'descNew' ? 'activeSort' : ''"></i>
              </p>
              <p 
                :class="(activeTab === 'descPrice' || activeTab === 'ascPrice') ? 'activeSort' : ''" 
                @click="priceSort('price')"
              >价格
                <i class="el-icon-caret-top" :class="activeTab === 'ascPrice' ? 'activeSort' : ''"></i>
                <i class="el-icon-caret-bottom" :class="activeTab === 'descPrice' ? 'activeSort' : ''"></i>
              </p>
            </div>
          </div>
          <div class="searchWrap">
            <el-input 
              v-model="searchInfo" 
              placeholder='搜索你想要的本店商品'
              prefix-icon="el-icon-search" 
              class="input-with-select"
              clearable
            >
              <el-button slot="append" @click="searchGoodStore">搜索</el-button>
            </el-input>
          </div>
        </div>
        <div class="good-list">
          <div class="goodItem" v-for="good of storeInfo.gbShopCommodities" :key="good.commodityId" @click="handleGoodDetail(good)">
            <div class="img">
              <img :src="getCommodityImg(good)" alt="">
              <img v-if="Number(good.reserve) === 0" class="soldOut1" src="@/assets/images/pt-soldOut.png" alt="">
            </div>
            <div class="info">
              <div>
                <div class="storeCommodity">
                  <img class="UImg" v-if="good.storeType === 'U'" src="@/assets/images/pt-yxdp.png" alt="">
                  <img class="SImg" v-if="good.storeType === 'S'" src="@/assets/images/pt-yxdp.png" alt="">
                  <div class="commodityName">{{ good.commodityName }}</div>
                </div>
                <div class="commodityTag">
                  <span class="tag" v-for="tag of good.tags" :key="tag.tagId">{{ tag.tagName }}</span>
                </div>
              </div>
              <div class="price">
                <span class="retail" v-if="good.pays[0].payType === 1">
                  <span class="symbol">¥</span>{{ getRetailPriceMin(good).retailPrice }}
                </span>
                <span class="retail" v-if="good.pays[0].payType === 2">
                  {{ getRetailPriceMin(good).retailPrice }}&nbsp;提货值
                </span>
                <span class="original" v-if="good.pays[0].payType === 1">
                  <span class="symbol">¥</span>{{ getRetailPriceMin(good).skuPrice }}</span>
                <span class="original" v-if="good.pays[0].payType === 2">
                  {{ getRetailPriceMin(good).skuPrice }}&nbsp;提货值
                </span>
                <span class="sold">已售{{ good.salesNumber }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="noMore" v-if="storeInfo.gbShopCommodities.length > 0">
          没有更多了
        </div>
        <div class="noMore" v-if="storeInfo.gbShopCommodities.length <= 0">
          暂无数据
        </div>
      </div>
      <!-- 分页 -->
      <!-- <el-row v-if="pageData.total" style="margin-top:10px">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row> -->
    </div>
    <div class="goBackIcon" @click="handleGoBack">
      <el-icon class="el-icon-back"></el-icon>
    </div>
    <Cellphone :phone="cellStore" ref="cellphoneRef" />
  </div>
</template>

<script>
import Cellphone from '@/views/equityMall/pt/components/cellStore.vue'
export default {
  components: {
    Cellphone
  },
  data() {
    return {
      cellStore: null,
      storeId: null,
      pageData: {
        total: null,
        pageSizes: [8, 16, 32, 64],
        pageSize: 8,
        currentPage: 1
      },
      storeInfo: {},

      activeTab: '',
      sort: [{
        'direction': 'ASC',
        'property': 'sortId'
      }],

      searchInfo: null,

      descShowStatus: false,
      isShow: false
    }
  },
  created() {
    this.storeId = this.$route.query.storeId
    this.queryCurrentStore()
  },
  methods: {
    // 返回上一页
    handleGoBack() {
      this.$router.go(-1)
    },

    handleChangeIsShow() {
      this.isShow = !this.isShow
    },

    // 跳转商品详情页
    handleGoodDetail(good) {
      this.$router.push({
        name: 'ptOrdinaryGoodDetail',
        query: {
          commodityId: good.commodityId,
          storeId: good.storeId,
        }
      })
    },

    // 提取商品主图
    getCommodityImg(commodity) {
      return commodity.imgs.find(img => Number(img.isMain) === 1).img
    },

    // 提取零售价(所有规格的最低价格)
    getRetailPriceMin(commodity) {
      let minObj = commodity.skus[0]
      commodity.skus.forEach(sku => {
        if (Number(sku.retailPrice) < Number(minObj.retailPrice) && Number(sku.display) === 1) {
          minObj = sku
        }
      })
      return minObj
    },

    // 联系商家
    handleStorePhone(phone) {
      this.cellStore = phone
      this.$refs.cellphoneRef.showDialog()
    },

    // 搜索商品
    searchGoodStore() {
      this.activeTab = 'ascNew'
      this.queryCurrentStore()
    },
    
    priceSort(type) {
      if (this.activeTab === 'descNew' || this.activeTab === 'descPrice') {
        this.activeTab = ''
        this.sort = [{
          'direction': 'DESC',
          'property': 'sortId'
        }]
        this.storeInfo.gbShopCommodities = [...this.storeInfo.gbShopCommodities].sort((a, b) => {
          const sortIdDiff = b.sortId - a.sortId
          if (sortIdDiff !== 0) {
            return sortIdDiff
          }
          return b.commodityId - a.commodityId
        })
        console.log(this.storeInfo.gbShopCommodities)
        return
      }
      if (type === 'new') {
        if (this.activeTab === 'ascNew') {
          this.activeTab = 'descNew'
          this.sort = [{
            'direction': 'DESC',
            'property': 'sortId'
          }]
          this.storeInfo.gbShopCommodities = [...this.storeInfo.gbShopCommodities].sort((a, b) => b.commodityId - a.commodityId)
        } else {
          this.activeTab = 'ascNew'
          this.sort = [{
            'direction': 'ASC',
            'property': 'sortId'
          }]
          this.storeInfo.gbShopCommodities = [...this.storeInfo.gbShopCommodities].sort((a, b) => a.commodityId - b.commodityId)
        }
      } else {
        if (this.activeTab === 'ascPrice') {
          this.activeTab = 'descPrice'
          this.sort = [{
            'direction': 'DESC',
            'property': this.userPrice
          }]
          this.storeInfo.gbShopCommodities = [...this.storeInfo.gbShopCommodities].sort((a, b) => {
            const minPriceDiff = b.minPrice - a.minPrice
            if (minPriceDiff !== 0) {
              return minPriceDiff
            }
            return b.commodityId - a.commodityId
          })
        } else {
          this.activeTab = 'ascPrice'
          this.sort = [{
            'direction': 'ASC',
            'property': this.userPrice
          }]
          this.storeInfo.gbShopCommodities = [...this.storeInfo.gbShopCommodities].sort((a, b) => a.minPrice - b.minPrice)
        }
      }
    },

    // 查询当前店铺信息
    queryCurrentStore() {
      const apiObj = JSON.parse(JSON.stringify(protocol.param_pt_queryStore))
      apiObj.param = {
        sort: [{direction: "DESC", property: "sortId"}],
        page: 0,
        size: 99999,
        storeId: Number(this.storeId),
        commodityName: this.searchInfo
      }
      http.postFrontMall(apiObj).then(response => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          this.pageData.total = value.totalElements
          this.isNetWrong = false
          const storeInfo = value.content[0]
          storeInfo.gbShopCommodities = [...storeInfo.gbShopCommodities].sort((a, b) => a.commodityId - b.commodityId)
          storeInfo.gbShopCommodities.forEach(commodity => {
            const minSku = this.getRetailPriceMin(commodity)
            commodity.minPrice = minSku.retailPrice
          })
          this.storeInfo = storeInfo
          this.storeInfo.gbShopCommodities = [...storeInfo.gbShopCommodities].sort((a, b) => {
            const sortIdDiff = b.sortId - a.sortId
            if (sortIdDiff !== 0) {
              return sortIdDiff
            }
            return b.commodityId - a.commodityId
          })
          this.$nextTick(() => {
            this.descShowStatus = this.$refs.description.scrollHeight > this.$refs.description.offsetHeight
          })
        } else {
          this.$message({ message: message })
          this.isNetWrong = true
          this.storeInfo = {}
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.queryAllStore()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.queryAllStore()
    },
  }
}
</script>

<style scoped lang="scss">
  .ordinaryStoreDetail-container {
    min-height: calc(100vh - 40px);
    background: #F4F4F4;
    display: flow-root;
    color: #000000;
    position: relative;
    .container {
      width: 1200px; 
      margin: 53px auto 20px;
      .store-detail {
        .store-header {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .store-header-left {
            display: flex;
            gap: 10px;
            .store-img {
              width: 68px;
              height: 68px;
              overflow: hidden;
              border-radius: 4px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .store-info {
              display: flex;
              flex-direction: column;
              gap: 3px;
              .store-type-name {
                display: flex;
                align-items: center;
                gap: 10px;
                .store-type {
                  height: 16px;
                }
                .store-name {
                  font-size: 16px;
                  color: #333333;
                }
              }
              .store-description {
                width: 300px;
                height: 20px;
                display: inline-block;
                overflow: hidden;
                font-size: 14px;
                color: #999999;
                position: relative;
                &.more {
                  display: inline;
                  height: auto;
                }
                .desc-openClose {
                  cursor: pointer;
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  background: #cccccc;
                  border-radius: 2px;
                  width: 60px;
                  text-align: center;
                }
              }
            }
          }
          .store-header-right {
            font-size: 16px;
            margin-top: 5px;
            .contact {
              cursor: pointer;
              color: #999999;
              /deep/ .el-icon-phone-outline {
                color: #999999;
              }
            }
          }
        }
        .good-search {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 12px;
          .good-filter {
            .sortWrap {
              display: flex;
              align-items: center;
              user-select: none;
              p {
                margin-right: 24px;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 14px;
                position: relative;
                cursor: pointer;
              }
              /deep/.el-icon-caret-top {
                position: absolute;
                font-size: 12px;
                top: -2px;
                color: #999999;
              }
              /deep/.el-icon-caret-bottom{
                position: absolute;
                font-size: 12px;
                bottom: -3px;
                color: #999999;
              }
              .activeSort{
                color: #1571DB;
              }
            }
          }
          .searchWrap {
            /deep/ .el-input {
              width: 630px;
              .el-input__inner{
                height: 44px;
                border-radius: 4px 4px 4px 4px;
                background:transparent;
                border: 1px solid #A5A6AC;
                font-size: 12px;
                font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
                font-weight: 400;
                color: #999999;
                box-sizing: border-box;
              }
              .el-input__icon {
                line-height: 44px;
                font-size: 12px;
              }
              .el-input-group__append{
                width: 104px;
                height: 44px;
                border:none;
                padding: 0;
                background: #1571DB;
                font-size: 16px;
                text-align: center;
                .el-button {
                  span {
                    color: #FFFFFF;
                  }
                }
              }
            }
          }
        }
        .good-list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 21px;
          gap: 21px;
          .goodItem {
            cursor: pointer;
            width: 284px;
            height: 380px;
            background: #FFFFFF;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            .img {
              width: 100%;
              height: 282px;
              background: #E4E4E4;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .soldOut1 {
                position: absolute;
                top: 0;
                left: 0;
                transform: scale(0.7);
              }
            }
            .info {
              flex: 1;
              padding: 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .storeCommodity {
                display: flex;
                align-items: center;
                gap: 6px;
                img {
                  height: 16px;
                }
                .commodityName {
                  font-size: 14px;
                  color: #333333;
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
              .commodityTag {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                gap: 6px;
                margin-top: 7px;
                .tag {
                  color: #ED732E;
                  font-size: 10px;
                  border: 1px solid #ED732E;
                  padding: 0 2px;
                }
              }
              .price {
                font-size: 14px;
                .retail {
                  color: #333333;
                  .symbol {
                    color: #333333;
                    font-size: 10px;
                  }
                }
                .original {
                  text-decoration: line-through;
                  color: #cccccc;
                  font-size: 10px;
                  .symbol {
                    color: #cccccc;
                    font-size: 10px;
                  }
                }
                .sold {
                  font-size: 12px;
                  color: #999999;
                  margin-left: 5px;
                }
              }
            }
          }
        }
        .noMore {
          color: #333333;
          font-size: 18px;
          font-weight: 500;
          height: 100px;
          line-height: 100px;
          text-align: center;
        }
      }
      // 分页样式
      /deep/ .el-pagination {
        .el-input {
          .el-input__inner {
            background: #ffffff;
          }
        }
      }
    }
    .goBackIcon {
      cursor: pointer;
      height: 40px;
      width: 40px;
      position: absolute;
      top: 30px;
      left: 50px;
      background: #666666;
      color: #ffffff;
      font-size: 30px;
      line-height: 40px;
      text-align: center;
      border-radius: 2px;
    }
  }
</style>